module.exports = __webpack_public_path__ + "static/media/white_img_d.093a0a5c.png";